const resultReducer = (state = '', action) => {
  switch(action.type) {
    case 'setResult':
      return state = action.payload
    default:
      return state
  }
}

export default resultReducer